<template lang="pug">
    el-dialog(:title="title",width="95%",:visible.sync='visible' :append-to-body='true' :modal-append-to-body='false')
        el-form(:model="ruleForm",:inline="true",label-suffix=":" label-width="90px")
            el-card(shadow="never")
                el-form-item(label="比赛ID" prop="matchId")
                    div.width_label {{ruleForm.matchId}}
                el-form-item(label="比赛名称" prop="matchName")
                    div.width_label {{ruleForm.matchName}}
                el-form-item(label="比赛类别")
                    div.width_label 俱乐部公开赛
                el-form-item(label="主办单位" prop="orgName")
                    div.width_label {{ruleForm.orgName}}
                el-form-item(label="比赛场地")
                    div.width_label {{ruleForm.placeName}}
                br
                el-form-item(label="赛事类型" prop="ctType")
                        div.width_label(v-if="ruleForm.ctType === 5") 月度赛-资格赛
                        div.width_label(v-if="ruleForm.ctType === 6") 月度赛-级别赛
                        div.width_label(v-if="ruleForm.ctType === 4") 年度总决赛
                el-form-item(label="签位" prop="applySize")
                        div.width_label {{ruleForm.joinCount}}/{{ruleForm.applySize}} 签
                el-form-item(label="比赛时间")
                        div.width_label {{ruleForm.matchStartTime}}
                el-form-item(label="状态")
                    div.width_label(v-if="ruleForm.matchStatus == 2") {{ruleForm.statusName}}
                    div.width_label(v-if="ruleForm.matchStatus == 3") 已取消
                    div.width_label(v-if="ruleForm.matchStatus == 4") 已结束
                br
                el-form-item(label="俱乐部名")
                  el-input(v-model="clubName" placeholder="请输入俱乐部名称" clearable='')
                el-button(@click='getEnrollData()',type='primary',icon='el-icon-search',style='float:right;margin-right:%2') 查 询
            el-row(style="padding-top:30px")
                el-col(:span="21")
                    el-button(type="primary" @click="addEnrollView" :disabled="ruleForm.enrollDisabled||ruleForm.matchStatus==4") 添加队伍
                    el-button(type="danger" @click="delEnrollClub(2)" :disabled="ruleForm.enrollDisabled||ruleForm.matchStatus==4") 删除队伍
                    el-button(type="primary" @click="clickRefund(2)" :disabled="ruleForm.matchStatus==4") 退 款
                    el-button(type="primary" @click="exportExcel") 名单导出
                el-col(:span="3")
                    //- el-button(type="primary" @click='openSortFormatr') 调整赛制
                    //- el-button(type="primary" @click='openSortNumber') 调整排序号
            el-row(style="padding-top:10px")
                el-col(:span="24")
                   el-card(shadow="never")
                      div
                        el-table(:data="enrollData" border @selection-change="enrollDataChangeEve")
                            el-table-column(type="selection" align='center' width='40')
                            el-table-column(prop="name" label="俱乐部" align='center')
                            el-table-column(prop="chairman" label="会长" align='center' width="130")
                            el-table-column(prop="yearScore" label="俱乐部积分" align='center' )
                                template(slot-scope="scope")
                                    font {{scope.row.yearScore||0}}
                            el-table-column(prop="mobile" label="会长账号" align='center' )
                            el-table-column(prop="isSixth" label="第六人" align='center')
                                template(slot-scope="scope")
                                    font(v-if="scope.row.isSixth === 0") 无
                                    font(v-if="scope.row.isSixth === 1") 有
                            el-table-column(prop="payStatus" label="状态" align='center' width="80")
                                template(slot-scope="scope")
                                    font(v-if="scope.row.payStatus == 0") 未缴费
                                    font(v-if="scope.row.payStatus == 1") 支付中
                                    font(v-if="scope.row.payStatus == 2") 已缴费
                                    font(v-if="scope.row.payStatus == 3") 支付失败
                                    font(v-if="scope.row.payStatus == 4") 超时
                                    font(v-if="scope.row.payStatus == 5") 申请退款
                                    font(v-if="scope.row.payStatus == 6") 退款中
                                    font(v-if="scope.row.payStatus == 7") 退款成功
                                    font(v-if="scope.row.payStatus == 8") 退款失败
                                    font(v-if="scope.row.payStatus == 9") 支付已关闭
                                    font(v-if="scope.row.payStatus == 10") 退款已取消
                            el-table-column(prop="payAmount" label="支付金额" align='center')
                                template(slot-scope="scope")
                                    font(v-if="scope.row.payAmount") ￥{{parseFloat(scope.row.payAmount).toFixed(2)}}元
                            el-table-column(prop="createTime" label="报名时间" align='center' width='170')
                            el-table-column(prop="refundScale" label="退款比例" align='center')
                                template(slot-scope="scope")
                                    font(v-if="scope.row.refundScale !== null") {{scope.row.refundScale}}%
                            el-table-column(prop="refundFee" label="退款金额" align='center')
                                template(slot-scope="scope")
                                    font(v-if="scope.row.refundFee !== null") ￥{{parseFloat(scope.row.refundFee).toFixed(2)}}元
                            el-table-column(prop="refundDesc" label="退款说明" align='center')
                                template(slot-scope="scope")
                                    font(v-if="!!scope.row.refundDesc") {{scope.row.refundDesc}}
                            el-table-column(header-align='center',align='center',label='操作' width='100')
                                template(slot-scope="scope")
                                    el-menu.menuPonit(:collapse="isCollapse" )
                                        el-submenu(index="1")
                                            template(slot="title")
                                                i(class="el-icon-more" style='color:#02B90D;')
                                            el-menu-item-group()
                                                el-menu-item(index="1-1" @click="viewMemberList(scope.row)") 查看队员
                                                el-menu-item(index="1-2" @click="addEnrollMember(scope.row)" :disabled="(canAddOrdel&&ruleForm.enrollDisabled)||ruleForm.matchStatus==4") 添加队员
                                                el-menu-item(index="1-3" @click="addSixMan(scope.row)" v-if="scope.row.isSixth!=1" :disabled="(canAddOrdel&&ruleForm.enrollDisabled)||ruleForm.matchStatus==4") 添加第六人
                                                el-menu-item(index="1-4" @click="deleteEnrollMember(scope.row)" :disabled="(canAddOrdel&&ruleForm.enrollDisabled)||ruleForm.matchStatus==4") 删除队员
                                                el-menu-item(index="1-5" @click="clickRefund(1,scope.row)" :disabled="ruleForm.matchStatus==4") 退款
                                                el-menu-item(index="1-5" @click="delEnrollClub(1,scope.row)" :disabled="ruleForm.enrollDisabled||ruleForm.matchStatus==4") 删除队伍
            //- el-row(style="padding-top:10px")
            //-     el-col(:span="24")
            //-         el-card(shadow="never")
            //-             div(slot="header")
            //-                 font.font_label add对阵表
            //-             div
            //-                 div(class="marginBottom")
            //-                   el-button(@click="chooseRound()") 1R
            //-                   el-button(@click="chooseRound()") 2R
            //-                   el-button(@click="chooseRound()") 3R
            //-                 el-table(:data="matchTableData" border)
            //-                     el-table-column(prop="matchTime" label="比赛时间" align="center")
            //-                     el-table-column(prop="name" label="姓名" align="center")
            //-                     el-table-column(prop="memberAccount" label="会员账号" align="center")
            //-                     el-table-column(prop="sex" label="性别" align="center")
            //-                     el-table-column(prop="age" label="年龄" align="center")
            //-                     el-table-column(prop="level" label="级别" align="center")
            //-                     el-table-column(prop="totalScore" label="积分" align="center")
            //-                     el-table-column(prop="memberType" label="会员类型" align="center")
            //-                     el-table-column(prop="yieldScore" label="让分" align="center" width="300")
            //添加队伍
            enroll-club-add(v-if='enrollClubAddVisiable', ref="enrollClubAdd", @refreshDataList='init')
            //查看队员
            enroll-club-member-view(v-if='enrollClubMemberViewVisiable', ref="enrollClubMemberView")
            //添加队员
            enroll-club-member-add(v-if='enrollClubMemberAddVisiable', ref="enrollClubMemberAdd")
            //删除队员
            enroll-club-member-delete(v-if='enrollClubMemberDeleteVisiable', ref="enrollClubMemberDelete", @refreshDataList='init')
            //添加第六人
            enroll-sixman-add(v-if='enrollSixmanAddVisiable', ref="enrollSixmanAdd", @refreshDataList='init')

            //退款
            el-dialog(title="退款" :visible.sync='refundVisible' :append-to-body='true' :modal-append-to-body='false' :close-on-click-modal='false')
                el-form(:model="refundForm" ref="refundForm" style="padding:30px;")
                    el-row
                       el-col(:span="8")
                            div(style="float:right")
                              el-radio(v-model="radio" label="1" border) 按比例退款
                       el-col(:span="16")
                            el-form-item(prop="refundScale" label="：" style="display:inherit;")
                                el-input-number(:disabled="radio==1 ? false : true" v-model="refundForm.refundScale" :min=0 :max=100 )
                    el-row
                        el-col(:span="8")
                            div(style="float:right")
                                el-radio(v-model="radio" label="2" border) 按固定金额退款
                        el-col(:span="16")
                            el-form-item(prop="refundFee" label="：" style="display:inherit;")
                                el-input-number(:disabled="radio==2 ? false : true" v-model="refundForm.refundFee" :min=0 :max="refundFeeMax" :precision="2" )
                    el-row
                        el-col(:span="8" style="margin-right:26px")
                            div(style="text-align:right;margin-right:-14px") 退款说明：
                        el-col(:span="8")
                            el-input(v-model="refundForm.refundDesc" type="textarea" :rows=6 resize="none" maxlength="99" show-word-limit)
                span.dialog-footer(slot="footer")
                    el-button(@click="comfirmRefundRee" type="primary" :disabled='refundBtn') 确 定
                    el-button(@click="refundVisible=false") 取 消
        //- SortNumber(v-if='SortNumberVisible', ref="SortBmber",@refreshDataList='choseSortBmber')
        //- SortFormat(v-if='SortFormatrVisible', ref="SortFormatr")
        span.dialog-footer(slot="footer")
            el-button(@click="visible=false") 返回
</template>
<script>
import table from './table.js'
import enrollClubAdd from './enroll-club-add'
import enrollClubMemberView from './enroll-club-member-view'
import enrollClubMemberAdd from './enroll-club-member-add'
import enrollClubMemberDelete from './enroll-club-member-delete'
import enrollSixmanAdd from './enroll-sixman-add'
// import SortNumber from './SortNumber'
// import SortFormat from './SortFormat'
export default {
  components: {
    enrollClubAdd,
    enrollClubMemberView,
    enrollClubMemberAdd,
    enrollClubMemberDelete,
    enrollSixmanAdd
    // SortNumber,
    // SortFormat
  },
  data () {
    return {
      canAddOrdel: false,
      isCollapse: true,
      table: {
        columns: table.columns,
        data: null,
        size: 'mini',
        stripe: true,
        border: true
      },
      SortFormatrVisible: false,
      SortNumberVisible: false,
      enrollClubAddVisiable: false, //添加队伍弹窗
      enrollClubMemberViewVisiable: false, //查看队员弹窗
      enrollClubMemberAddVisiable: false, //添加队员
      enrollClubMemberDeleteVisiable: false, //删除队员
      enrollSixmanAddVisiable: false, //添加第六人
      addOrViewArgue: true,
      refundBtn: false, //退款按钮禁用
      argueTitle: '',
      argueForm: {
        argue: ''
      },
      refundList: [],
      memberMobile: '',
      buttonSize: 'large',
      options: [],
      value: '',
      clubName: '',
      visible: false,
      refundVisible: false,
      title: '参赛人员管理',
      enrollData: [],
      enrollDataChange: [],
      ruleForm: {
        id: '',
        ctId: '',
        matchName: '',
        orgId: '',
        city: '',
        province: '',
        placeId: '',
        ctType: '',
        applySize: '',
        projectType: null,
        level: '',
        bench: '0',
        applyDate: [],
        matchSignStartTime: '',
        matchSignEndTime: '',
        matchStartTime: '',
        imgList: '',
        gameDescription: '',
        matchDescription: '',
        imgDetailList: '',
        repeatSign: '0',
        genderLimit: '2',
        ageLimit: '',
        ageMinMen: undefined,
        ageMaxMen: undefined,
        ageMinWomen: undefined,
        ageMaxWomen: undefined,

        scoreMin: '',
        ctRefundList: [],
        byx1: '',
        verifyReason: '',
        orderForm: 1,
        enrollDisabled: false
      },
      payRefund: null,
      refundForm: {
        refundScale: undefined,
        refundFee: undefined,
        refundDesc: ''
      },
      radio: undefined,
      loading: null,
      refundFeeMax: 0,
      matchTableData: [] // 对阵表数据
    }
  },
  methods: {
    // 调整序列号
    openSortNumber () {
      this.SortNumberVisible = true
      this.$nextTick(() => {
        this.$refs.SortBmber.init(
          this.enrollDataOne,
          this.ruleForm.id,
          this.ruleForm.projectType
        )
      })
    },
    // 调整赛制
    openSortFormatr () {
      this.SortFormatrVisible = true
      this.$nextTick(() => {
        this.$refs.SortFormatr.init()
      })
    },
    choseSortBmber () {
      this.SortNumberVisible = false
    },
    openFullScreen () {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    init (id) {
      if (id) {
        this.ruleForm.id = id
      }
      this.radio = undefined
      this.visible = true
      this.enrollData = []
      this.enrollDataChange = []
      //回选
      this.$http({
        url: this.$http.adornUrl(`/ctCompetition/getId/` + this.ruleForm.id),
        method: 'get'
      })
        .then((data) => {
          if (data && data.code === 0) {
            this.ruleForm = data.bean
            console.log(this.ruleForm, '竞赛信息')
            let joinCount = this.ruleForm.joinCount //已报名参赛人员的人数
            let applySize = this.ruleForm.applySize //赛事签位数
            let date1 = new Date().getTime()
            let date2 = new Date(this.ruleForm.matchStartTime).getTime()
            let date3 = new Date(this.ruleForm.matchSignStartTime).getTime()
            let date4 = new Date(this.ruleForm.matchSignEndTime).getTime()
            // this.ruleForm.enrollDisabled = true
            if (date1 < date3) {
              this.ruleForm.statusName = '未开始'
              // this.ruleForm.enrollDisabled = false
            } else if (
              date1 >= date3 &&
              date1 <= date4 &&
              joinCount < applySize
            ) {
              this.ruleForm.statusName = '报名中'
              // this.ruleForm.enrollDisabled = false
            } else if (
              date1 >= date3 &&
              date1 <= date4 &&
              joinCount >= applySize
            ) {
              this.ruleForm.statusName = '已报满'
              // this.ruleForm.enrollDisabled = false
            } else if (date1 > date4 && date1 < date2) {
              this.ruleForm.statusName = '报名结束'
              // this.ruleForm.enrollDisabled = false
            } else if (date1 >= date2) {
              this.ruleForm.statusName = '已开赛'
              // this.ruleForm.enrollDisabled = true
            }
            //报名结束后 比赛开始前可添加删除人员

            // if(date4<date1&&date1<date2){
            //     this.canAddOrdel = false
            // }else{
            //     this.canAddOrdel = true
            // }
          }
        })
        // 获取对阵表数据
        this.getEnrollData()
    },
    // 参赛人员管理-对阵表信息
    getMatchTableData (id) {
      // this.$http({
      //   url: this.$http.adornUrl(
      //     `/ctCompetition/operation/player-manage/against-list/${id}`
      //   ),
      //   method: 'get'
      // }).then((data) => {
      //   if (data && data.data.code === 0) {
      //     this.matchTableData = data.data
      //   }
      // })
    },
    //列表刷新
    getEnrollData () {
      let params = { ctId: this.ruleForm.id, clubName: this.clubName }
      this.$http({
        url: this.$http.adornUrl(`/elEnroll/getClubEnrollListByCtId`),
        method: 'post',
        params: this.$http.adornParams(params)
      }).then((data) => {
        if (data && data.code === 0) {
          console.log(data)
          this.enrollData = data.list
          this.table.data = data.list
          for (let i of this.enrollData) {
            if (i.refundScale === null && i.refundFee !== null) {
              i.refundScale = ((i.orderFee / i.refundFee) * 100).toFixed(2)
            }
            if (i.refundFee === null && i.refundScale !== null) {
              i.refundFee = ((i.orderFee * i.refundScale) / 100).toFixed(2)
            }
          }
        }
      })
    },
    //添加参赛队伍页面
    addEnrollView () {
      this.enrollClubAddVisiable = true
      this.$nextTick(() => {
        this.$refs.enrollClubAdd.init(this.ruleForm, this.enrollData)
      })
    },

    //查看队员
    viewMemberList (row) {
      this.enrollClubMemberViewVisiable = true
      this.$nextTick(() => {
        this.$refs.enrollClubMemberView.init(row)
      })
    },
    //添加队员弹窗
    addEnrollMember (row) {
      this.enrollClubMemberAddVisiable = true
      this.$nextTick(() => {
        this.$refs.enrollClubMemberAdd.init(row, this.ruleForm)
      })
    },
    //删除队员弹窗
    deleteEnrollMember (row) {
      this.enrollClubMemberDeleteVisiable = true
      this.$nextTick(() => {
        this.$refs.enrollClubMemberDelete.init(row, this.ruleForm)
      })
    },
    //添加第六人
    addSixMan (row) {
      this.enrollSixmanAddVisiable = true
      console.log('this.$refs.enrollSixmanAdd', this.$refs.enrollSixmanAdd)
      this.$nextTick(() => {
        this.$refs.enrollSixmanAdd.init(row, this.ruleForm)
      })
    },
    //删除队伍
    delEnrollClub (btn, row) {
      let idArr = []
      if (btn === 1) {
        //单个删除
        if (
          row.payStatus === 2 ||
          row.payStatus === 5 ||
          row.payStatus === 6 ||
          row.payStatus === 8 ||
          row.payStatus === 10
        ) {
          this.$message.error('提示：请先进行退费操作!')
          return
        }
        idArr.push(row.id)
      } else {
        //批量删除
        if (this.enrollDataChange.length === 0) {
          this.$message.error('提示：请勾选要删除的队伍！')
          return
        }
        console.log(this.enrollDataChange, '要删除的队伍')
        for (let i of this.enrollDataChange) {
          console.log('遍历要删除的队伍', i)
          if (
            i.payStatus === 2 ||
            i.payStatus === 5 ||
            i.payStatus === 6 ||
            i.payStatus === 8 ||
            i.payStatus === 10
          ) {
            this.$message.error('提示：请先进行退费操作!')
            return
          }
          idArr.push(i.id)
        }
      }
      console.log('要删除的参赛队伍：', idArr.toString())
      this.$confirm('是否删除该队伍', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          this.$http({
            url: this.$http.adornUrl(`/elEnroll/deleteByEnroll`),
            method: 'post',
            params: this.$http.adornParams({
              ids: idArr.join()
            })
          }).then((data) => {
            if (data && data.code === 0) {
              if (data.state) {
                this.$message.success('删除成功')
                this.init()
              } else {
                this.$message.error(data.info)
              }
            }
          })
        })
        .catch(() => {
          this.$message.info('已取消')
        })
    },
    //退款事件
    clickRefund (btn, row) {
      console.log('退款按钮：', row)
      this.radio = undefined
      this.payRefund = {}
      //支付状态(-1全部，0未支付,1支付中,2支付成功,3支付失败,4超时,5申请退款,6退款中,7退款成功,8退款失败,9支付已关闭，10退款已取消)
      if (btn === 1) {
        //操作栏退款
        if (
          row.payStatus == 0 ||
          row.payStatus == 1 ||
          row.payStatus == 3 ||
          row.payStatus == 4
        ) {
          this.$message.error('提示：未缴费不能退款！')
          return
        }
        if (row.payStatus == 5) {
          this.$message.error('提示：已发起退款申请！')
          return
        }
        if (row.payStatus == 6 || row.payStatus == 8) {
          this.$message.error('提示：退款中！')
          return
        }
        if (row.payStatus == 7) {
          this.$message.error('提示：已完成退款！')
          return
        }
        this.payRefund.ids = row.id
        this.refundFeeMax = parseFloat(row.payAmount).toFixed(2)
      } else {
        //批量退款
        if (this.enrollDataChange.length === 0) {
          this.$message.error('提示：请勾选要退费的人员！')
          return
        }
        console.log('勾选的退款人员', this.enrollDataChange)
        let feeFlag = false
        let feeInfo = ''
        let idArr = []
        this.refundFeeMax = parseFloat(
          this.enrollDataChange[0].payAmount
        ).toFixed(2)
        this.enrollDataChange.forEach((row) => {
          if (
            row.payStatus == 0 ||
            row.payStatus == 1 ||
            row.payStatus == 3 ||
            row.payStatus == 4
          ) {
            feeInfo = '提示：未缴费不能退款！'
            feeFlag = true
            return
          }
          if (row.payStatus == 5) {
            feeInfo = '提示：已发起退款申请！'
            feeFlag = true
            return
          }
          if (row.payStatus == 6 || row.payStatus == 8) {
            feeInfo = '提示：退款中！'
            feeFlag = true
            return
          }
          if (row.payStatus == 7) {
            feeInfo = '提示：已完成退款！'
            feeFlag = true
            return
          }
          idArr.push(row.id)
          //退款金额赋最大值
          if (this.refundFeeMax > parseFloat(row.payAmount).toFixed(2)) {
            this.refundFeeMax = parseFloat(row.payAmount).toFixed(2)
          }
        })
        if (feeFlag) {
          this.$message.error(feeInfo)
          return
        }
        console.log('已选退费人员id：', idArr)
        console.log('已选退费人员id：', idArr.toString())
        this.payRefund.ids = idArr.toString()
      }
      this.refundVisible = true
      this.refundForm.refundScale = undefined
      this.refundForm.refundFee = undefined
      this.refundForm.refundDesc = ''
      this.refundFeeMax = parseFloat(this.refundFeeMax)
    },
    //退款提交事件
    comfirmRefundRee () {
      console.log('退款信息：', this.refundForm)
      if (this.radio === undefined) {
        this.$message.error('请选择按比例或者固定金额退款!')
        return
      }
      if (this.radio === '1') {
        if (!this.refundForm.refundScale) {
          this.$message.error('请填写退款比例!')
          return
        } else {
          this.payRefund.refundScale = this.refundForm.refundScale
          this.payRefund.refundFee = undefined
          this.refundForm.refundFee = undefined
        }
      }
      if (this.radio === '2') {
        if (!this.refundForm.refundFee) {
          this.$message.error('请填写固定金额退款!')
          return
        } else {
          this.payRefund.refundFee = this.refundForm.refundFee
          this.payRefund.refundScale = undefined
          this.refundForm.refundScale = undefined
        }
      }
      console.log('退款确定：', this.payRefund, this.radio, this.refundForm)
      this.refundBtn = true
      this.payRefund.refundDesc = this.refundForm.refundDesc; // 退款说明
      this.$http({
        url: this.$http.adornUrl(`/elEnrollOrder/refund`),
        method: 'post',
        data: this.payRefund
      }).then((data) => {
        if (data && data.code === 0) {
          this.$message.success('操作成功！')
          this.refundVisible = false
          this.refundBtn = false
          this.getEnrollData()
        }
      })
    },
    //参数队伍勾选事件
    // eslint-disable-next-line vue/no-dupe-keys
    enrollDataChangeEve (val) {
      this.enrollDataChange = val
    },

    //导出excel
    exportExcel () {
      let params = { ctId: this.ruleForm.id, clubName: this.clubName }
      this.$http({
        url: this.$http.adornUrl(`/elEnroll/getClubEnrollExportList`),
        method: 'post',
        params: this.$http.adornParams(params)
      }).then((data) => {
        if (data && data.code === 0) {
          console.log(data)
          this.table.data = data.list
          if (this.table.data == null || this.table.data.length === 0) {
            this.$message.info('没有要导出的数据!')
            return
          }
          let index = 1
          for (let i of this.table.data) {
            i.index = index++
            i.gender = { 0: '男', 1: '女' }[i.gender]
          }
          let title = this.ruleForm.matchName || ''
          this.$export
            .excel({
              columns: this.table.columns,
              data: this.table.data,
              title: title + '参赛人员'
            })
            .then(() => {
              this.$message.success('导出表格成功')
            })
        }
      })
    }
  }
}
</script>
<style>
.active {
  background: #02b90d !important;
  color: #fff !important;
}
.marginBottom {
  margin-bottom: 20px;
}
.width_label {
  width: 180px;
}
.opSetting {
  text-align: center;
  margin-top: 30px;
}
.spacing {
  margin-top: 10px;
}
.font_label {
  font-weight: bold;
  font-size: 18px;
}
</style>
